// extracted by mini-css-extract-plugin
export var readtime = "W_cT";
export var simpleReadtime = "W_cV";